module.exports = typeof window == 'object' && typeof Deno != 'object';